import React from "react";

export interface IProps {
	tabs: string[];
	defaultIndex?: number;
	onChange?: (index: number) => void;
	style?: React.CSSProperties
}

export class AppTabs extends React.Component<IProps> {

	state = { activeIndex: this.props.defaultIndex || 0 };

	handleTabClick = (activeIndex: number) => {
		if (activeIndex === this.state.activeIndex) return;
		this.props && this.props.onChange && this.props.onChange(activeIndex)
		this.setState({ activeIndex });
	}

	renderList = () => {
		let { tabs } = this.props;
		let { activeIndex } = this.state;

		return (<ul className="app-tabs-list">
			{tabs.map((tab: string, index) => {
				let className = index === activeIndex ? "app-tab app-tab-active" : "app-tab"
				return (<li className={className} key={index} onClick={() => this.handleTabClick(index)}>{tab}</li>);
			})}
		</ul>);
	}

	render() {
		return (
		<React.Fragment>
		<div className="app-tabs" style={this.props.style}>{this.renderList()}</div>
		{this.props.children}
		</React.Fragment>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/AppTabs/index.tsx